module.exports = __webpack_public_path__ + "static/media/SWSCRC6-36.2feac51e.mp3";